export const selectUpsellsContent = propertyCode => state => state.upsells?.data[propertyCode];
